import React from "react";
import { Link } from "react-router-dom";
import logo  from "../../assets/images/newlogo.jpg";

const AdminHeader = ({
  backTo,
  backLabel = "Dashboard",
  showLogout = false,
  onLogout,
}) => {
  return (
    <header className="admin-header">
      <div className="admin-brand">
        <div className="admin-brand-icon">
            <img src={logo} alt="Sudhamshu Ayurveda" />
        </div>

        <div>
          <h2>Sudhamshu Ayurveda</h2>
          <span>Administration Panel</span>
        </div>
      </div>

      <div className="admin-header-actions">

        {/* Show Back button only when backTo is provided */}
        {backTo && (
          <Link to={backTo} className="admin-back-btn">
            ← {backLabel}
          </Link>
        )}

        {showLogout && (
          <button
            type="button"
            onClick={onLogout}
            className="admin-logout-btn"
          >
            Logout
          </button>
        )}

      </div>
    </header>
  );
};

export default AdminHeader;